import {
  getAllCoupons,
  inactiveCoupon,
} from "../../../Redux/Coupon/CouponActions";
import { ColDef, GridReadyEvent, ICellRendererParams } from "ag-grid-community";
import Loading from "../../../Components/Common/Loading/Loading";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { AppDispatch, RootState } from "../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router";
import { HiDotsVertical } from "react-icons/hi";
import { IoCloseSharp } from "react-icons/io5";
import { AgGridReact } from "ag-grid-react";
import styles from "./Coupons.module.scss";
import moment from "moment";

interface CouponsType {
  id: number;
  name: string;
  percent: number;
  maxDiscount: number;
  voucherType: number;
  isActive: boolean;
  createdAt: string;
  createdBy: number;
  startDate: string;
  endate: string;
  modifiedAt: string | null;
  modifiedBy: number | null;
  voucherlimit: number;
}

const defaultColDef: ColDef = {
  resizable: true,
  sortable: true,
  filter: false,
  wrapText: true,
  autoHeight: true,
  unSortIcon: true,
};

function Coupons() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { coupons, couponsLoading, inactiveCouponLoading } = useSelector(
    (state: RootState) => state.coupons,
  );
  const [rowData, setRowData] = useState<CouponsType[]>([]);
  const [gridApi, setGridApi] = useState<any>(null);
  const [search, setSearch] = useState("");

  const filteredRowData = rowData?.filter((item) =>
    item?.name?.toLowerCase()?.includes(search?.toLowerCase()),
  );

  const onGridReady = (params: GridReadyEvent) => {
    setGridApi(params?.api);
    params?.api?.sizeColumnsToFit();
  };

  const inactiveCouponHandler = (id: string) => {
    if (!inactiveCouponLoading && id) {
      const successHandler = () => {
        dispatch(getAllCoupons());
      };
      dispatch(inactiveCoupon({ id, successHandler }));
    }
  };

  const columnDefs: ColDef<CouponsType>[] = [
    {
      headerName: "Name",
      field: "name",
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Percent",
      field: "percent",
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Max Discount",
      field: "maxDiscount",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => {
        return `$ ${params?.data?.maxDiscount}`;
      },
    },

    {
      headerName: "Voucher Limit",
      field: "voucherlimit",
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Voucher Type",
      field: "voucherType",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => {
        if (params?.data?.voucherType === 1) {
          return "Package";
        } else if (params?.data?.voucherType === 2) {
          return "Booking";
        } else {
          return "N/A";
        }
      },
    },
    {
      headerName: "Expires On",
      field: "endate",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => {
        return moment(params?.data?.endate).format("MM/DD/YYYY");
      },
    },
    {
      headerName: "Status",
      flex: 1,
      minWidth: 150,
      cellClass: (params) => {
        return params?.data?.isActive ? "activeText" : "expiredText";
      },
      valueGetter: (params) => {
        return params?.data?.isActive ? "Active" : "Inactive";
      },
    },

    {
      sortable: false,
      suppressAutoSize: true,
      suppressMovable: true,
      suppressNavigable: true,
      editable: false,
      cellStyle: {
        pointerEvents: "all",
        userSelect: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      },
      cellRenderer: (params: ICellRendererParams) => {
        return (
          <div className={styles.iconContainer}>
            <Menu
              direction="left"
              menuButton={
                <MenuButton>
                  <HiDotsVertical className={styles.icon} />
                </MenuButton>
              }
              transition
              portal
            >
              <MenuItem
                onClick={() =>
                  navigate(`/admin/coupons/edit/${params?.data?.id}`)
                }
              >
                Edit
              </MenuItem>

              <MenuItem
                onClick={() =>
                  inactiveCouponHandler(params?.data?.id?.toString())
                }
              >
                Delete
              </MenuItem>
            </Menu>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    if (!gridApi) return;

    const handleResize = () => {
      gridApi?.sizeColumnsToFit();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [gridApi]);

  useEffect(() => {
    dispatch(getAllCoupons());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (coupons) {
      setRowData(coupons);
    }
  }, [coupons]);

  return (
    <React.Fragment>
      {couponsLoading && <Loading />}
      <div className={styles.mainContainer}>
        <div className={styles.topContainer}>
          <div className={styles.headingContainer}>
            <h1 className={styles.heading}>Manage Coupons</h1>
          </div>
          <div className={styles.buttonContainer}>
            <Link to="/admin/coupons/add" className={styles.buttonContainer}>
              <button className={styles.button}>Add Coupon</button>
            </Link>
          </div>
        </div>
        <div className={styles.bodyContainer}>
          <div className={styles.searchContainer}>
            <input
              type="text"
              className={styles.input}
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e?.target?.value || "")}
            />
            <div className={styles.iconContainer} onClick={() => setSearch("")}>
              <IoCloseSharp className={styles.icon} />
            </div>
          </div>

          <div className={styles.gridContainer}>
            <AgGridReact
              className={styles.grid}
              rowData={filteredRowData}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              onGridReady={onGridReady}
              pagination={true}
              paginationPageSize={10}
              paginationPageSizeSelector={[5, 10, 20, 50, 100]}
              animateRows={true}
              domLayout="autoHeight"
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Coupons;
